import { render } from "./MultiImageUploader.vue?vue&type=template&id=4a2504fc&scoped=true"
import script from "./MultiImageUploader.vue?vue&type=script&lang=js"
export * from "./MultiImageUploader.vue?vue&type=script&lang=js"

import "./MultiImageUploader.vue?vue&type=style&index=0&id=4a2504fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2504fc"]])

export default __exports__